// The single source of truth for panel permissions.
//
// A permission is assignable only if a route actually gates on its key. Keep
// this list, the `meta.permission` values in src/router/index.js, and the
// hasPermission() checks in src/components/AdminAside.vue in agreement — when
// they drifted apart, some checkboxes did nothing and some pages were locked
// for everyone or open to everyone.

export const PERMISSIONS = [
  { title: "الرئيسية", key: "dashboard" },
  { title: "الطلاب", key: "students" },
  { title: "المشرفين", key: "admins" },
  { title: "الاكواد", key: "codes" },
  { title: "التصنيفات", key: "categories" },
  { title: "الدروس", key: "lessons" },
  { title: "الاختبارات", key: "exams" },
  { title: "تعليقات الفيديوهات", key: "video_comments" },
  { title: "المذكرات والمراجعات", key: "reviews" },
  { title: "صور توضيحيه", key: "images" },
  { title: "الاخبار", key: "posts" },
  { title: "ثقف نفسك", key: "informations" },
  { title: "الفصول", key: "classes" },
  { title: "المجموعات", key: "groups" },
  { title: "المستخدمين", key: "users" },
  { title: "الاعلانات", key: "banners" },
  { title: "العروض", key: "offers" },
  { title: "اتصل بنا", key: "contact" },
];

export const PERMISSION_KEYS = PERMISSIONS.map((permission) => permission.key);

export function isAssignablePermission(key) {
  return PERMISSION_KEYS.includes(key);
}

// Drops keys no route gates on, so a stale array cannot grant anything.
export function sanitizePermissions(permissions) {
  if (!Array.isArray(permissions)) return [];
  return permissions.filter((key) => isAssignablePermission(key));
}
